import {FormControl, FormField, FormItem} from "@/components/ui/form.tsx";
import {Input} from "@/components/ui/input.tsx";
import {FieldPath, FieldValues} from "react-hook-form";

export default function HiddenField<T extends FieldValues>(
    {name}: { name: FieldPath<T> }) {
    return (<FormField name={name} render={({field}) => (
        <FormItem>
            <FormControl>
                <Input type="hidden" {...field} />
            </FormControl>
        </FormItem>
    )}/>)
}